module.exports = __webpack_public_path__ + "img/faq-disabled.2bc5c11e.svg";